import { httpClient } from 'common/services';
import type {
  ReturnToQueueRequest,
  ReturnToQueueResponse,
} from 'features/return-to-queue/interfaces';

export class ReturnToQueueDaoService {
  static async returnToQueue({ callId, ...rest }: ReturnToQueueRequest) {
    const route = `/call/${callId}/return-to-queue`;
    const response = await httpClient.patch<ReturnToQueueResponse>(route, rest);
    return response.data;
  }
}
